// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"99":"LazyGoogleOneTap","873":"LazyIdentificationForm"}[chunkId] + "." + {"99":"e35667b6e8d0dc8dcf6b","873":"a98ae0eb3d12fd012aa8"}[chunkId] + ".js";
};